import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { init } from '@amplitude/analytics-browser';
import {ThemeProvider} from "./Components/ThemeSwitching/theme-provider";

const getUserClientId = () => {
    if (localStorage.getItem("dimensions_client_id")) {
        return localStorage.getItem("dimensions_client_id")
    }

    localStorage.setItem("dimensions_client_id", Math.random().toString(36).substr(2, 18));
    return localStorage.getItem("dimensions_client_id")
}

init("e6d30c4d368373816518c53d1b868542", getUserClientId());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider>
        <App />
    </ThemeProvider>
);
